export default __webpack_public_path__ + "static/media/title.576a80c5.svg";